import { useEffect } from 'react';
import Image from 'next/image';
import gsap from 'gsap';

const AnimCard3 = () => {
  useEffect(() => {
    gsap
      .timeline({
        repeat: -1,
        delay: 2
      })
      .fromTo(
        '.anim-card-3-billete-js',
        {
          autoAlpha: 0,
          x: 15
        },
        {
          autoAlpha: 1,
          x: 0,
          ease: 'power2.out'
        }
      )
      .fromTo(
        '.anim-card-3-box-js',
        {
          autoAlpha: 0,
          y: -15
        },
        {
          autoAlpha: 1,
          y: 0,
          ease: 'bounce.out'
        }
      )
      .fromTo(
        '.anim-card-3-bag-js',
        {
          autoAlpha: 0,
          y: 5
        },
        {
          autoAlpha: 1,
          y: 0,
          ease: 'power2.out',
          duration: 2
        }
      );
  }, []);

  return (
    <>
      <div className="absolute z-1 inset-0">
        <Image
          src="/images/animcards/3/chicas.svg"
          width={228}
          height={193}
          alt=""
          style={{ width: '100%', height: 'auto' }}
          className="object-cover"
        />
      </div>
      <div className="absolute z-3 top-[15%] right-[6%] w-[21px] h-[70px]">
        <Image
          src="/images/animcards/3/arm.svg"
          fill
          alt=""
          className="object-cover"
        />
      </div>
      <div className="absolute top-[25%] right-[35%] | anim-card-3-billete-js">
        <Image
          src="/images/animcards/3/billete.svg"
          width={24}
          height={12}
          alt=""
          style={{ width: '100%', height: 'auto' }}
          className="object-cover"
        />
      </div>
      <div className="absolute z-2 top-[45%] right-[11%] | anim-card-3-bag-js">
        <Image
          src="/images/animcards/3/bag.svg"
          width={29}
          height={43}
          alt=""
          style={{ width: '100%', height: 'auto' }}
          className="object-cover"
        />
      </div>
      <div className="absolute top-[18.5%] left-[38%]  | anim-card-3-box-js">
        <Image
          src="/images/animcards/3/box.svg"
          width={30}
          height={25}
          alt=""
          style={{ width: '100%', height: 'auto' }}
          className="object-cover"
        />
      </div>
    </>
  );
};
export default AnimCard3;
